<template>
  <div>
    <!-- <current-path /> -->
    <NameComponent responseName="topic" resName="topics" />
  </div>
</template>

<script>
export default {
  name: "Topics",
  components: {
    NameComponent: () => import("@/components/NameComponent")
  }
};
</script>
